import { render, staticRenderFns } from "./TrainBook.vue?vue&type=template&id=20e904ec&"
import script from "./TrainBook.vue?vue&type=script&lang=js&"
export * from "./TrainBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports